/**
 * Appends properties 'type' and 'country' to user object.
 * @param  {Object} [user] - the user object
 * @param  {Object} [momentTZ] - utility for managing dates and time
 * @return {Object} [user]
 */
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import countriesList from "country-list";

const countries = countriesList();

const appendTypeAndCountry = function appendTypeAndCountry(user, momentTZ) {
  user = cloneDeep(user);
  user.country = countries.getName(user.country);

  if (
    get(user, "admin", false) ||
    get(user, "permissions", []).includes("admin")
  ) {
    user.type = "admin";
    return user;
  }
  if (
    get(user, "ambassador", false) ||
    get(user, "permissions", []).includes("ambassador")
  ) {
    user.type = "ambassador";
    return user;
  }
  if (get(user, "stripe", false)) {
    if (
      user.stripe.plan !== "launch_freeTrial" &&
      user.stripe.plan !== "free_trial"
    ) {
      user.type =
        momentTZ().diff(user.stripe.period_end) < 0 ? "paid" : "expired";
      // user.type += " (plan: " + user.stripe.plan + ")"
    } else {
      user.type = "trial";
    }
  }
  return user;
};

export default appendTypeAndCountry;
